import React, { useEffect } from 'react';
import LoginMethods from '../../pages/login/LoginMethods';

function LoginModal({ open, redirectPath, onClose, onSuccess }) {
  useEffect(() => {
    if (!open) return undefined;

    const previousOverflow = document.body.style.overflow;
    const closeOnEscape = (event) => {
      if (event.key === 'Escape') onClose();
    };

    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', closeOnEscape);
    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener('keydown', closeOnEscape);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="canvas-login-modal-backdrop" onMouseDown={onClose}>
      <section
        className="canvas-login-panel canvas-login-modal"
        role="dialog"
        aria-modal="true"
        aria-label="登录剧查查超级工厂"
        onMouseDown={(event) => event.stopPropagation()}
      >
        <button
          className="canvas-login-modal-close"
          type="button"
          aria-label="关闭登录弹窗"
          onClick={onClose}
        >
          ×
        </button>
        <LoginMethods redirectPath={redirectPath} onSuccess={onSuccess} />
      </section>
    </div>
  );
}

export default LoginModal;
